//
import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CustomerClient } from "../../parentApi";

const client = new CustomerClient(app_uri, axiosClient());

export default client;
